<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de produção">
            <rkm-layout-content v-if="loaded">
                <List
                    :data="{ initials, form, model, additionals }"
                    @handleList="handleList"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/exame-imagem/relatorio-producao/List'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { List },
    created() {

        this.repositories = {
            relatorio: this.getConectaSusRepository('exameImagem.relatorioProducao')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorio.list()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleList(data) {

            this.form = this.clone(data.form)
            this.additionals = this.clone(data.additionals)
        },
    },
    mixins: [repository, error, object, data]
}
</script>